export enum TipoCqInizio {
  noCq = -1,
  oneEachMaterial = 0,
  oneForAllMaterial = 1,
  oneEachBox = 2
}

export const TIPO_CQ_INIZIO = [
  { value: TipoCqInizio.noCq, text: 'Non mostrare', newValue: ''},
  {value: TipoCqInizio.oneForAllMaterial, text: 'Uno per tutto il materiale', newValue: ''},
  {value: TipoCqInizio.oneEachMaterial, text: 'Per ogni materiale', newValue: ''},
  {value: TipoCqInizio.oneEachBox, text: 'Per ogni contenitore ', newValue: ''}
];
